import React, { useEffect, useMemo, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import ParkPackagesFilters from "./ParkPackagesFilters";
import { useParksViewContext } from "provider/ParkViewProvider";
import { useMasterContext } from "provider/MasterProvider";
import apiCall from "components/Api/api";
import SelectedFiltersParkWise from "./SelectedFiltersParkWise";
import rupeeFormat from "components/Api/RupeeFormat";
// import SafariMobileFilter from "components/safaripackages/view/SafariMobileFilter";
import SafariPackageCard from "components/safaripackages/view/SafariPackageCard";
import { useScreenSize } from "provider/ScreenSizeProvider";
import ParkPackagesMobileFilter from "./ParkPackagesMobileFilter";


const ParkPackages = () => {
  const { parkSlug } = useParams();
  const {
    parkWisePackages,
    parkDetail,
    packageSummary,
    pageIndex,
    filters,
    parksViewDispatch,
  } = useParksViewContext();
  const { safariPackSortBy } = useMasterContext();
  const [loading, setLoading] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const { isMobileView } = useScreenSize();

  const handleFilterClick = () => {
    setShowFilter(true);
  };

  useEffect(() => {
    const fetchSafariPackages = async () => {
      try {
        setLoading(true)
        let query = [];

        Object.entries(filters).forEach(([key, value]) => {
          if (Array.isArray(value) && value.length > 0) {
            value.forEach((v) => {
              query.push(`${key}[]=${encodeURIComponent(v)}`);
            });
          } else if (value !== 0 && value !== null && value !== "") {
            query.push(`${key}=${encodeURIComponent(value)}`);
          }
        });

        if (packageSummary?.pageSize) {
          query.push(`pageSize=${packageSummary.pageSize}`);
        }

        if (pageIndex) {
          query.push(`page=${pageIndex}`);
        }

        const queryString = query.length > 0 ? `?${query.join("&")}` : "";
        const response = await apiCall({
          url: `park/${parkSlug}/park-package${queryString}`,
          method: "GET",
        });
        if (response?.status === 200) {
          if (response?.data?.errors) {
            const errors = response?.data.errors;
            // Dynamically set errors based on the response
            console.error(errors);
          } else {
            const postData = response?.data?.packages?.data || [];
            const summary = response?.data?.packages?.summary;
            if (pageIndex === 1) {
              parksViewDispatch({
                type: "SET_PARKS_VIEW_PACKAGE_DATA",
                payload: postData,
              });
            } else {
              parksViewDispatch({
                type: "APPEND_PARKS_VIEW_PACKAGE_DATA",
                payload: postData,
              });
            }

            parksViewDispatch({
              type: "SET_PARKS_VIEW_PACKAGES_SUMMARY",
              payload: {
                total: summary.total,
                page: summary.page,
                pageSize: summary.pageSize,
                total_page: summary.total_page,
              },
            });
          }
        }
      } catch (err) {
        console.error("Error fetching safaris:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchSafariPackages();
  }, [packageSummary?.pageSize, filters, pageIndex]);


  const handleSortChange = (e) => {
    const value = Number(e.target.value);
    updateFilter("custom_sort_by", value);
  };

  const updateFilter = (name, value) => {
    parksViewDispatch({
      type: "UPDATE_PARKS_VIEW_PACKAGE_FILTER",
      payload: { [name]: value },
    });
  };

  const processedSafariPackages = useMemo(() => {
    return parkWisePackages?.map((packages) => ({
      ...packages,
    }));
  }, [parkWisePackages, pageIndex]);
  return (
    <>
      <Row>
        <Col lg={3} xl={3} xxl={2} className="">
          {!isMobileView && <ParkPackagesFilters />}
          {isMobileView && <div
            id="targetDiv"
            className="mobileDive"
            style={{ display: showFilter ? "block" : "none" }}
          >
            <ParkPackagesMobileFilter onCancel={() => setShowFilter(false)} />
          </div>}
        </Col>
        {isMobileView && <Col xs={12} className="px-0 d-lg-none">
          <div className="top_mobilefilter d-flex gap-2  justify-content-between align-items-center w-100 mb-4">
            <div className="left_text">
              <p className="mb-0">
                There are currently{" "}
                <strong>{processedSafariPackages?.length || 0}</strong> active
                packages
              </p>
            </div>
            <div className="right-select mobile_serach mb-md-0 ">
              <div class="input_check pb-0">
                <div class="filter_searchbox" onClick={handleFilterClick}>
                  <span>
                    Filter <i class="fa-solid fa-chevron-down"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </Col>
        }
        <Col lg={9} xl={9} xxl={10}>
          <div className="card card_bodyPadding add_new border-0 park-pack-bg">
            <div className="card-body">
              <div className="backgroud_oprator py-4 ">
                <Row>
                  {!isMobileView && <Col lg={12} xl={12} xxl={12} className="position-relative">
                    <div className="topfilter d-lg-flex d-none justify-content-between w-100 mb-2">
                      <div className="left_text w-100">
                        <p className="mb-0">
                          We found{" "}
                          <strong>{processedSafariPackages?.length}</strong>{" "}
                          safari packages in {parkDetail?.title}
                        </p>
                      </div>
                      <div className="right-select d-flex gap-2 align-items-center pe-xl-2">
                        <div className="input_check pb-0">
                          <div className="form-group field-safarioperatorsearch-custom_sort_by">
                            <select
                              id="packagesearch-custom_sort_by"
                              className="form-control custom_sort_by_input"
                              name="custom_sort_by"
                              value={filters?.custom_sort_by}
                              onChange={handleSortChange}
                            >
                              {safariPackSortBy?.map((option) => (
                                <option key={option.value} value={option.value}>
                                  {option.label}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                  }
                  <SelectedFiltersParkWise />
                </Row>
                <Row className="row row-cols-1 row-cols-sm-2 row-cols-md-2 row-cols-lg-2 row-cols-xl-2 row-cols-xxl-3 gx-xxl-2 g-xl-4 gx-xxl-4">
                  {processedSafariPackages?.map((safariPackages, index) => {
                    return (
                      <Col
                        className="mb-xl-0 mb-md-3 mb-4 padding_righ"
                        key={safariPackages.id || index}
                      >
                        <SafariPackageCard safariPackages={safariPackages} />
                      </Col>
                    );
                  })}
                </Row>
                <div className="d-flex justify-content-center my-4">
                  {loading ? (
                    <div
                      className="spinner-border loading-spinner"
                      role="status"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  ) : (
                    packageSummary?.page < packageSummary?.total_page && (
                      <button
                        className="join_btn newbgjoin mt-sm-0 mt-2"
                        onClick={() => {
                          const newPageIndex = pageIndex + 1;
                          parksViewDispatch({
                            type: "SET_PARKS_VIEW_PACKAGE_PAGE_INDEX",
                            payload: newPageIndex,
                          });
                        }
                        }
                      >
                        Show More packages
                      </button>
                    )
                  )}
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default ParkPackages;
